(function() { window.GUID_26541304_ee49_4ab5_bba2_1f3e7964edf3 = { getGuid: function() { return "26541304-ee49-4ab5-bba2-1f3e7964edf3"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class TopBar {
            constructor(topBarId) {
                let me = this;
                TopBar.Instance = me;
                this.topBarId = topBarId;
                this.$TopBar = $(topBarId);
                me.$NotificationsContent = me.$TopBar.find(".notifications-content");
                me.bindEvents();
            }
            bindEvents() {
                let me = this;
                me.$TopBar.offon("click." + this.topBarId, function (e) {
                    let $target = $(e.target);
                    if (!$target.hasClass("clickable")) {
                        $target = $target.closest(".clickable");
                    }
                    let id = $target.attr("id");
                    if ($target.hasClass("button-back")) {
                        if ($target.data("gotohome") == true) {
                            CS.Nav.GoToDefault();
                        }
                        else {
                            CS.Nav.GoBack();
                        }
                    }
                    else if (id == "button-refresh") {
                        CS.Nav.Refresh();
                    }
                });
                this.setSubTopStickyValue();
                CS.DOM.$win.offon("resize.SupTopBar", () => {
                    CS.Lag("resizeSupTopBar", 150, () => {
                        this.setSubTopStickyValue();
                    });
                });
                this.$TopBar.offon(`click.Analytics-topbar-${this.topBarId}`, ".topbar-ga-events-trigger", (e) => {
                    const $trigger = $(e.currentTarget);
                    if ($trigger.length) {
                        const { category, action, label, value, isValid } = CS.Helper.GoogleAnalyticsHelper.getDataFromElement($trigger);
                        if (isValid) {
                            CS.Analytics.Event(category, action, label, value);
                        }
                    }
                });
            }
            setSubTopStickyValue() {
                const $innerSubtop = $(".section-inner-subtop").last();
                if ($innerSubtop.length > 0) {
                    const topbarHeight = this.$TopBar.outerHeight();
                    const $searchBar = $innerSubtop.find(".app__search-bar");
                    let top = topbarHeight;
                    if ($searchBar.length > 0) {
                        const searchbarHeight = $searchBar.outerHeight();
                        top -= searchbarHeight;
                    }
                    $innerSubtop.css({
                        top: `${Math.floor(top) - 0.5}px`,
                    });
                }
            }
        }
        Controls.TopBar = TopBar;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=top-bar.pre.js.map
